// src/App.js
import React, { useState, useEffect } from 'react';
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom';

import Header from './components/Header';
import Hero from './components/Hero';
import Welcome from './components/Welcome';
// import Categories from './components/Categories';
import Gallery from './components/Gallery';
import Brands from './components/Brands';
import Clients from './components/Clients';
import Products from './components/Products';
// import Stats from './components/Stats';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';

import './App.css';

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [pendingScrollId, setPendingScrollId] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  // Track scroll for header styling
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 🔥 Scroll to top on *every* route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  // Basic scroll on the homepage
  const doScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth',
      });
    }
    setIsMenuOpen(false);
  };

  // Public function used by Header/Footer
  const scrollToSection = (id) => {
    // If we're not on the home page, go home first,
    // then scroll when home is rendered
    if (location.pathname !== '/') {
      setPendingScrollId(id);
      navigate('/');
      return;
    }

    // Already on home: just scroll
    doScroll(id);
  };

  // After navigating back to "/", perform the pending scroll
  useEffect(() => {
    if (location.pathname === '/' && pendingScrollId) {
      const t = setTimeout(() => {
        doScroll(pendingScrollId);
        setPendingScrollId(null);
      }, 0); // wait a tick so DOM is ready
      return () => clearTimeout(t);
    }
  }, [location, pendingScrollId]);

  return (
    <div className="font-montserrat text-gray-700 bg-white overflow-x-hidden">
      <Header
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        scrollY={scrollY}
        scrollToSection={scrollToSection}
      />

      <Routes>
        {/* Home page */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Welcome />
              {/* <Categories /> */}
              <Gallery />
              <Brands />
              <Clients />
              <Products />
              {/* <Stats /> */}
              <Contact />
            </>
          }
        />

        {/* Privacy / Policy page */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Catch-all: any /random etc. → redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer scrollToSection={scrollToSection} />
    </div>
  );
};

export default App;
